import { forwardRef } from 'react';
import { BaseButton, type BaseButtonProps } from '@/Components/Common/Buttons/BaseButton';
import { cn } from '@/lib/utils';

const SubmitButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
    ({ className, type = 'submit', ...props }, ref) => {
        return (
            <BaseButton
                ref={ref}
                type={type}
                className={cn('bg-primary text-primary-foreground shadow hover:bg-primary/90', className)}
                {...props}
            />
        );
    },
);
SubmitButton.displayName = 'SubmitButton';

export { SubmitButton };
